import PropTypes from 'prop-types';

export const locationShape = {
  id: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string,
  airportCode: PropTypes.string,
  parentId: PropTypes.number,
  type: PropTypes.string,
  toLabel: PropTypes.string,
  toAirportCode: PropTypes.string,
  dates: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  searchIdType: PropTypes.string,
};
